// Shared query definitions, small enough to live in the main bundle so the
// router can start fetching a list while the screen's code is still loading.
import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";
import { api, type CandidateRow, type ClientRow, type Page } from "./api.ts";

export function listParams(search: string, status: string, cursor: string, consultant = "") {
	const params = new URLSearchParams({ limit: "50" });
	if (consultant) params.set("consultant", consultant);
	if (search) params.set("q", search);
	// "bookable" means the computed flag (stage plus valid documents), not a stage.
	if (status === "bookable") params.set("bookable", "1");
	else if (status === "free" || status === "finishing") params.set("work", status);
	else if (status) params.set("status", status);
	if (cursor) params.set("cursor", cursor);
	return params;
}

export const candidateListQuery = (search: string, status: string, consultant = "") =>
	infiniteQueryOptions({
		queryKey: ["candidates", { search, status, consultant }],
		queryFn: ({ pageParam }) =>
			api<Page<CandidateRow>>(`/candidates?${listParams(search, status, pageParam, consultant)}`),
		initialPageParam: "",
		getNextPageParam: (last) => last.nextCursor ?? undefined,
		staleTime: 15_000,
	});

export const clientListQuery = (search: string, status: string, consultant = "") =>
	infiniteQueryOptions({
		queryKey: ["clients", { search, status, consultant }],
		queryFn: ({ pageParam }) => api<Page<ClientRow>>(`/clients?${listParams(search, status, pageParam, consultant)}`),
		initialPageParam: "",
		getNextPageParam: (last) => last.nextCursor ?? undefined,
		staleTime: 15_000,
	});

/** The agency's registration address, offered on Add a candidate as the quicker way. */
export const registrationAddressQuery = queryOptions({
	queryKey: ["registration-address"],
	queryFn: () => api<{ address: string | null }>("/registration-address"),
	staleTime: 300_000,
});
